import React, { FC } from 'react';
import { graphql } from 'gatsby';

import createBreadcrumbs from 'utils/createBreadcrumbs';
import Layout from 'layout/Layout';
import FaqAccordion from 'components/Faq/FaqAccordion';
import FaqCategory from 'components/Faq/FaqCategory';
import SectionTitle from 'common/SectionTitle';
import PageSchema from 'common/PageSchema';

import 'styles/main.scss';
import './FaqPage.scss';
import { FaqPageProps } from './models';

const FaqPage: FC<FaqPageProps> = ({
  data: {
    faqPage: {
      title,
      seoMetaTitle,
      seoMetaDescription,
      seoMetaKeywords,
      seoNoIndex,
      faq,
      faqCategories,
    },
    allSitePage: { nodes },
  },
  pageContext: {
    breadcrumb: { crumbs },
    areBreadcrumbsDisplayed,
  },
  location: { pathname },
}) => {
  const breadcrumbs = createBreadcrumbs(crumbs, areBreadcrumbsDisplayed, nodes, pathname);

  return (
    <Layout
      className="faq-page"
      headerTransparent
      breadcrumbs={breadcrumbs}
      seo={{ seoMetaTitle, seoMetaDescription, seoMetaKeywords, seoNoIndex }}
    >
      <PageSchema
        type="WebPage"
        name={seoMetaTitle}
        data={{
          metaTitle: seoMetaTitle,
          metaDescription: seoMetaDescription,
          metaKeywords: seoMetaKeywords,
        }}
      />
      <SectionTitle text={title} isMainTitle />
      <div className="faq-section">
        <div className="faq-categories">
          {faqCategories?.length
            ? faqCategories.map((item) => <FaqCategory value={item.value} key={item.value} />)
            : null}
        </div>
        {faq?.length
          ? faq.map((item, index) => (
              <FaqAccordion
                {...item.properties}
                key={faqCategories[index].value}
                categoryId={faqCategories[index].value}
              />
            ))
          : null}
      </div>
    </Layout>
  );
};

export const query = graphql`
  query {
    faqPage {
      title
      ...SeoFragment
      faq {
        ...FaqAccordionFragment
      }
      faqCategories {
        value
      }
    }
    allSitePage {
      ...FragmentAllPageSite
    }
  }
`;

export default FaqPage;
